import React from "react";
import ResultInfoText from "./ResultInfoText.js";
import { useNavigate } from "react-router-dom";
import CopyTextUniversalButton from "../CopyTextUniversalButton.js";

function MoleculeInfo({ molecule, interactiveSearch, textSize = "16px" }) {
    const row = Math.floor(Math.random() * 100);
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(`/record/${molecule.marts}`);
    };

    return (
        <div style={{ textAlign: "center" }}>
        <ResultInfoText text={molecule.name} row={row} navigationLink={`/record/${molecule.marts}`} fontSize={textSize}/>  <CopyTextUniversalButton smiles={molecule.smiles} />
        <br />
        {molecule.chebi ? (
             <ResultInfoText text={molecule.marts} row={row} linkText={`Find in ChEBI: ${molecule.chebi}`}
            link={`https://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:${molecule.chebi}`} navigationLink={`/record/${molecule.marts}`} fontSize={textSize}/>
        ) : (
             <ResultInfoText text={molecule.marts} row={row} fontSize={textSize} navigationLink={`/record/${molecule.marts}`}/>
        )} <CopyTextUniversalButton smiles={molecule.marts} copiedText="MARTS ID" />
       
        </div>
    )
}

export default MoleculeInfo;